import { AfterViewInit, Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';

type StringOrNumber = string | number;

@Directive({ selector: '[portalCyTest]', standalone: true })
export class CyTestDirective implements AfterViewInit {
  @Input('portalCyTest') name?: StringOrNumber | StringOrNumber[];
  private readonly cyAttribute = 'data-cy';
  private readonly eRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  ngAfterViewInit() {
    if (this.name) {
      let name = this.name;
      if (Array.isArray(name)) name = name.join('.');
      this.renderer.setAttribute(this.eRef.nativeElement, this.cyAttribute, name.toString());
    }
  }
}
